
import { defineComponent, ref } from 'vue';
import Card from '@/core/components/Tela/Card.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { IOrdemProducaoCip } from '@/models/Entidades/PCP/IOrdemProducao';

export default defineComponent({
  name: 'OrdemProducaoCip',
  components: {
    Card,
  },
  props: {
    cips: {
      type: Array as () => IOrdemProducaoCip[],
      required: true,
    },
  },
  setup(props) {
    const chaveExpandida = ref('');

    function formatarMoeda(valor: number): string {
      return (valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    function formatarData(data: string): string {
      if (!UtilitarioGeral.valorValido(data)) {
        return '';
      }

      return UtilitarioData.aplicaFormatoData(data);
    }

    function obterNomeEstrutura(cip: any): string {
      return cip.nomeCipEstrutura || cip.descricaoCipEstrutura || '';
    }

    function obterNomeCategoria(categoria: any): string {
      return categoria.nomeCategoriaFinanceira
        || categoria.nomePlanoContaCategoria
        || categoria.descricaoPlanoContaCategoria
        || '';
    }

    function obterChaveCip(cip: any, index: number): string {
      return `${cip.codigo}-${cip.codigoCipEstrutura}-${index}`;
    }

    function estaExpandido(chave: string): boolean {
      return chaveExpandida.value === chave;
    }

    function alternarExpansao(chave: string): void {
      chaveExpandida.value = chaveExpandida.value === chave ? '' : chave;
    }

    return {
      props,
      UtilitarioGeral,
      formatarMoeda,
      formatarData,
      obterNomeEstrutura,
      obterNomeCategoria,
      obterChaveCip,
      estaExpandido,
      alternarExpansao,
    };
  },
});
